import script from "./VisitPayHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitPayHistory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__